const CustomLoadingIndicatorStyle = {
	loadingIndicator: {
		position: 'fixed',
		width: '100%',
		zIndex: 2500,
		'& .MuiLinearProgress-bar': {
			animationDuration: '4s',
			'&:last-of-type': {
				animationDelay: '2.5s',
			},
		},
	},
};

export default CustomLoadingIndicatorStyle;
